import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { auth, createUserWithEmailAndPassword } from 'config/firebase';
import SignUpVector from 'assets/vectors/SignUp.svg';
import TextInput from 'components/TextInput';
import Button from 'components/Button';
import SignInWithGoogle from 'components/SignInWithGoogle';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setAlert } from 'store/error';
import './index.css';

function SignUp() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');

    const dispatch = useAppDispatch();
    const { organization } = useAppSelector(state => state.organization);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (password !== confirm) {
            // console.log('The passwords don\'t match!');
            dispatch(setAlert({
                response: {
                    data: {
                        message: 'The passwords don\'t match!'
                    }
                }
            }));
        }
        else {
            createUserWithEmailAndPassword(auth, email, password)
                // .then(userCredential => {
                //     console.log(userCredential.user);
                // })
                .catch(error => {
                    dispatch(setAlert({
                        response: {
                            data: {
                                message: error.message
                            }
                        }
                    }));
                });
        }
    }

    return (
        <div className='layout'>
            <Helmet>
                <title>
                    Sign up - {organization.name}
                </title>
            </Helmet>
            <form className='signUp' onSubmit={handleSubmit}>
                <img
                    className='signUp__vector'
                    src={SignUpVector}
                    alt='Sign Up'
                />
                <h1 className='signUp__header'>
                    Create your account
                </h1>
                <TextInput
                    name='email'
                    label='email address'
                    onChange={(event) => setEmail(event.target.value)}
                    required
                    type='email'
                    value={email}
                />
                <TextInput
                    name='password'
                    label='password'
                    onChange={(event) => setPassword(event.target.value)}
                    required
                    type='password'
                    value={password}
                />
                <TextInput
                    name='confirm'
                    label='confirm password'
                    onChange={(event) => setConfirm(event.target.value)}
                    required
                    type='password'
                    value={confirm}
                />
                <Button
                    className='signUp__button'
                    // disabled={!email || !password || !confirm}
                    fullWidth
                    secondary={!email || !password || !confirm}
                    type='submit'
                >
                    CREATE ACCOUNT
                </Button>
                {/* <SignInWithGoogle /> */}
                <div className='signUp__action'>
                    <p className='signUp__actionText'>
                        Already have an account?
                    </p>
                    <Link to='/sign-in' className='signUp__actionLink'>
                        Sign in here
                    </Link>
                </div>
            </form>
        </div>
    );
}

export default SignUp;